// Utilitaires de texte sans dépendance (chargés par la coquille).

/** Initiales pour l'avatar : « Issouf Kaboré » → « IK ». */
export function initials(fullName: string): string {
  return fullName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
